import { ChartNodeData } from "@/components/chart/Chart.tsx";
import { UserCard } from "@/components/user-card/UserCard.tsx";
import { Button, Stack, FontAwesomeIcon } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface ChartNodeProps<T> {
  expanded: boolean;
  data: ChartNodeData<T>;
}

// No relative positioning in child nodes: Safari breaks it inside dagre-d3 SVG.
export function ChartNode<T>({ data, expanded = false }: ChartNodeProps<T>) {
  return (
    <Stack
      className={twMerge(
        "rounded-lg p-4 bg-light h-full structure-item border-2 border-transparent transition-all",
        "hover:border-dark/10",
        expanded && "border-dark hover:border-dark"
      )}
      direction={"vertical"}
      justify={"between"}
      items={"center"}
      gap={"sm"}
      id={`structure-node__${data.id}`}
      data-id={data.id}
    >
      <UserCard
        title={data.title}
        size={"sm"}
        caption={data.caption}
        extra={data.extra}
        avatarElement={data.avatarElement}
        avatarUrl={data.imgUrl ?? ""}
        textEllipsis={true}
      />
      {data.count ? (
        <Button
          className={"chart-expand-button"}
          data-id={data.id}
          variant={expanded ? "primary" : "secondary"}
          rightIcon={
            expanded ? (
              <FontAwesomeIcon icon="fa-light fa-chevron-down" />
            ) : (
              <FontAwesomeIcon icon="fa-light fa-chevron-right" />
            )
          }
        >
          {data.count}
        </Button>
      ) : (
        ""
      )}
    </Stack>
  );
}
